import { render, staticRenderFns } from "./LojaIntegradaSvg.vue?vue&type=template&id=5be65a50"
import script from "./LojaIntegradaSvg.vue?vue&type=script&lang=js"
export * from "./LojaIntegradaSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports